module.exports = __webpack_public_path__ + "static/media/Nuacem.935254e0.png";